import Plugin from 'src/plugin-system/plugin.class';
import createHTMLMapMarker from 'src/helper/custom-marker.helper';

export default class InternationalMapPlugin extends Plugin {

    init() {
        //this._initMap();
    }

    _retrieveMarkers() {

        let markers = [];

        document.querySelectorAll('.international-map-widget__dealer').forEach((element) => {
            markers.push(this._parseMarker(element));

        });

        return markers;
    }

    _retrieveMarkersContent() {

        let markersContent = [];

        document.querySelectorAll('.international-map-widget__dealer').forEach((element) => {
            markersContent.push(this._parseMarkerContent(element));

        });

        return markersContent;
    }

    _retrieveMarkersTitle() {

        let markersTitle = [];

        document.querySelectorAll('.international-map-widget__dealer').forEach((element) => {
            markersTitle.push(this._parseMarkerTitle(element));

        });

        return markersTitle;
    }

    _parseMarker(element) {

        let lat = parseFloat(element.dataset.lat);
        let lng = parseFloat(element.dataset.lng);

        let marker = [
            {
                lat: lat,
                lng: lng
            },
            element.innerHTML
        ];

        return marker;
    }

    _parseMarkerContent(element) {
        let markerContent = element.innerHTML;
        return markerContent;
    }

    _parseMarkerTitle(element) {
        let markerTitle = element.dataset.title;
        return markerTitle;
    }

    _initMap() {

        this.overlay = new google.maps.OverlayView();
        this.overlay.draw = function () {};

        this.map = new google.maps.Map(document.getElementById("map"), {
            zoom: 4.6,
            center: {
                lat: 45.3274675,
                lng: 6.0827138
            },
            styles: [
                {
                    "featureType": "all",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.landcover",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.landcover",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "color": "#d3d3d3"
                        },
                        {
                            "saturation": "-85"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#d3d3d3"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#d3d3d3"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.airport",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.bus",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.rail",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ],
            //mapTypeId: 'terrain',
            gestureHandling: 'cooperative',
            zoomControl: true,
            disableDefaultUI: true

        });

        google.maps.event.addListenerOnce(this.map, 'idle', () => {

            this.markers = this._retrieveMarkers();
            this.markersContent = this._retrieveMarkersContent();
            this.markersTitle = this._retrieveMarkersTitle();

            // Create the markers.
            this.markers.forEach(([position, content], i) => {

                createHTMLMapMarker({
                    latlng: new google.maps.LatLng(position),
                    map: this.map,
                    boxContent: content,
                    html: `<div class="custom-marker__title">` + this.markersTitle[i] + `</div>
                        <svg class="custom-marker__icon" xmlns="http://www.w3.org/2000/svg" height="6" width="6" viewBox="0 0 6 6">
                            <circle id="Ellipse_625" data-name="Ellipse 625" cx="3" cy="3" r="3" fill="#00B2E3" />
                        </svg>`
                });

            });

            createHTMLMapMarker({
                latlng: {
                    lat: 50.3888412,
                    lng: 7.231509
                },
                map: this.map,
                boxContent: `
                    <div class="custom-marker__card card">
                        <div class="card-header">
                            <span>` + this.options.default_germany + `</span>
                        </div>
                        <div class="card-body">
                            ` + this.options.default_germany_address + `
                        </div>
                    </div>
                `,
                html: `<div class="custom-marker__title">Deutschland</div><svg class="custom-marker__icon xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 21.73 18.4">
                            <g id="Ebene_2" data-name="Ebene 2">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <rect width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="7.63" width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="15.27" width="21.73" height="3.13" fill="#00B2E3" />
                                </g>
                            </g>
                        </svg>`
            });

            createHTMLMapMarker({
                latlng: {
                    lat: 49.78504148581715,
                    lng: 89.73155613093394
                },
                map: this.map,
                boxContent: `
                    <div class="custom-marker__card card">
                        <div class="card-header">
                            <span>` + this.options.default_header + `</span>
                        </div>
                        <div class="card-body">
                            ` + this.options.default_body + `
                        </div>
                    </div>
                `,
                html: `<svg class="custom-marker__icon xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 21.73 18.4">
                            <g id="Ebene_2" data-name="Ebene 2">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <rect width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="7.63" width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="15.27" width="21.73" height="3.13" fill="#00B2E3" />
                                </g>
                            </g>
                        </svg>`
            });

            createHTMLMapMarker({
                latlng: {
                    lat: 53.491526367228765,
                    lng: -102.74890931294158
                },
                map: this.map,
                boxContent: `
                    <div class="custom-marker__card card">
                        <div class="card-header">
                            <span>` + this.options.default_header + `</span>
                        </div>
                        <div class="card-body">
                            ` + this.options.default_body + `
                        </div>
                    </div>
                `,
                html: `<svg class="custom-marker__icon xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 21.73 18.4">
                            <g id="Ebene_2" data-name="Ebene 2">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <rect width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="7.63" width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="15.27" width="21.73" height="3.13" fill="#00B2E3" />
                                </g>
                            </g>
                        </svg>`
            });

            createHTMLMapMarker({
                latlng: {
                    lat: -17.722185406054386,
                    lng: -57.397345926862215
                },
                map: this.map,
                boxContent: `
                    <div class="custom-marker__card card">
                        <div class="card-header">
                            <span>` + this.options.default_header + `</span>
                        </div>
                        <div class="card-body">
                            ` + this.options.default_body + `
                        </div>
                    </div>
                `,
                html: `<svg class="custom-marker__icon xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 21.73 18.4">
                            <g id="Ebene_2" data-name="Ebene 2">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <rect width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="7.63" width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="15.27" width="21.73" height="3.13" fill="#00B2E3" />
                                </g>
                            </g>
                        </svg>`
            });

            createHTMLMapMarker({
                latlng: {
                    lat: 8.78808,
                    lng: 22.38629
                },
                map: this.map,
                boxContent: `
                    <div class="custom-marker__card card">
                        <div class="card-header">
                            <span>` + this.options.default_header + `</span>
                        </div>
                        <div class="card-body">
                            ` + this.options.default_body + `
                        </div>
                    </div>
                `,
                html: `<svg class="custom-marker__icon xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 21.73 18.4">
                            <g id="Ebene_2" data-name="Ebene 2">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <rect width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="7.63" width="21.73" height="3.13" fill="#00B2E3" />
                                    <rect y="15.27" width="21.73" height="3.13" fill="#00B2E3" />
                                </g>
                            </g>
                        </svg>`
            });

        });

    }

}
